// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__36-8I","amount":"Amount_amount__1BNif","tip":"Amount_tip__1hRTO","tipHeader":"Amount_tipHeader__3gYok","tipsWrap":"Amount_tipsWrap__3DeCX"};